export default __webpack_public_path__ + "1089ffddb3db02e747158585f6c16f44.png";